import { render, staticRenderFns } from "./bill copy.vue?vue&type=template&id=c89d094e&scoped=true&"
import script from "./bill copy.vue?vue&type=script&lang=js&"
export * from "./bill copy.vue?vue&type=script&lang=js&"
import style0 from "./bill copy.vue?vue&type=style&index=0&id=c89d094e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89d094e",
  null
  
)

export default component.exports